<template>
  <el-tabs v-model="activeName" class="tabs">
    <div class="help">
      <p><strong>【注】：</strong>扫描下方二维码，关注<span class="orange">【心理亦笙】</span>公众号，用于接收消息，取消关注后将无法收到消息</p>
      <img src="../../assets/img/official.jpg" alt="">
    </div>
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【绑定微信】</span></p>
        <img src="../../assets/img/bindChat_a.png" alt="">
        <p><strong>第二步：</strong>请使用【微信App】的【扫一扫】功能，扫描弹窗中的二维码</p>
        <img src="../../assets/img/bindChat_b.png" alt="">
        <p><strong>第三步：</strong>扫描后请在【微信App】中点击<span class="orange">【确认绑定】<br/>
        注：微信app提示需要用户授权，请点击【允许】
        </span>
        </p>
        <img src="../../assets/img/bindChat_c.png" alt="">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh ">
          <p><strong>第一步：</strong>在【菜单栏】中<span class="orange">【绑定微信】</span>按钮</p>
          <p><strong>第二步：</strong>在【绑定微信】页面，再次输入信息，点击<span class="orange">【绑定】</span></p>
          <p><strong>第三步：</strong>在【绑定微信】弹窗中，点击<span class="orange">【确认】</span></p>
        </div>
        <img src="../../assets/img/bindChat_d.png" alt="">
      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
export default {
  name: "bingWechat",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/help";
</style>
